/*
  object: {
    route-name: api-key
  }
*/
import __t from '@/booksy-vue-components/utils/__t'
import { EVENT_ACTIONS } from '@/lib/analytics/consts.ts'

export const PROMOTION_FEATURES_KEYS = {
  'invite-customers': 'invite_customers',
  'boost': 'boost',
  'social-media': 'social_media',
  'message-clients': 'message_clients',
  'special-offers': 'service_promotions',
  'message-blast': 'message_blast',
  'visibility-promotion': 'visibility_promotion',
}

export const SPECIAL_OFFERS_TYPES = {
  LAST_MINUTE: 'last-minute',
  FLASH_SALE: 'flash-sale',
  HAPPY_HOURS: 'happy-hours',
  PEAK_HOURS: 'peak-hours',
}

export const SPECIAL_OFFERS_KEYS = {
  [SPECIAL_OFFERS_TYPES.LAST_MINUTE]: 'last_minute',
  [SPECIAL_OFFERS_TYPES.FLASH_SALE]: 'flash_sale',
  [SPECIAL_OFFERS_TYPES.HAPPY_HOURS]: 'happy_hours',
  [SPECIAL_OFFERS_TYPES.PEAK_HOURS]: 'peak_hours',
}

// MESSAGE BLASTS INTERNAL NAMES
export const MESSAGE_BLAST_GROUP_ENUM = {
  FIRST_IMPRESSION: 'first_impression',
  REACTIVATE: 'reactivate',
  SPECIAL_OCCASIONS: 'special_occasions',
  YOUR_OWN_MESSAGES: 'own_message',
  MORE_OCCASIONS: 'more_occasions',
  ONE_TIME_MESSAGE: 'one_time_message',
  SPECIAL_MESSAGE_BLAST: 'special_message_blast',
}

export const MESSAGE_BLAST_INTERNAL_NAMES = {
  WELCOME_NEW_CLIENT: 'welcome_new_client',
  INFORM_ABOUT_OTHER_SERVICES: 'inform_about_other_services',
  PROMOTE_GIFT_CARDS: 'promote_git_cards',
  INVITE_FOR_VISIT: 'invite_for_visit',
  REINVITE_FREE_SERVICE: 'reinvite_free_services',
  REINVITE_DISCOUNT: 'reinvite_discount',
  HAPPY_BIRTHDAY: 'happy_birthday',
}

export const SPECIAL_OCCASIONS_INTENRAL_NAMES = {
  CHRISTMAS: 'christmas',
  EASTER: 'easter',
  FATHERS_DAY: 'fathers_day',
  MOTHERS_DAY: 'mothers_day',
  HALLOWEEN: 'halloween',
  NEW_YEARS_DAY: 'new_years_day',
  THANGSGIVING: 'thanksgiving',
  VALENTINES_DAY: 'valentines_day',
}

export const ONE_TIME_MESSAGES_INTERNAL_NAMES = {
  INFORM_ABOUT_NEW_OPENING: 'inform_about_new_opening',
  INFORM_ABOUT_TIME_OFF: 'inform_about_time_off',
  INFORM_ABOUT_NEW_SERVICES: 'inform_about_new_services',
  INVITE_TO_EVENT: 'invite_to_event',
  ASK_FOR_REFERRAL: 'ask_for_referral',
  INFORM_ABOUT_PRICE_CHANGES: 'inform_about_price_changes',
  OWN_MESSAGE: 'own_message',
}

export const EVENT_NAMES = {
  SET_CUSTOMERS: 'set-customers',
  SET_TEMPLATE_TO_SEND: 'set-template-to-send',
}

export const LINK_INTERNAL_NAMES = {
  MORE_OCCASIONS: 'more_occasions_link',
  ONE_TIME_MESSAGE: 'one_time_message_link',
  SPECIAL_MESSAGE_BLAST: 'special_message_blast_link',
}

export const ACTIVE = 'active'
export const INACTIVE = 'inactive'

export const BOOST_CLIENT_STATUS = {
  NO_SHOW: {
    name: __t('components.promotion.boost.no-show'),
    value: 'no_show',
  },
  FIRST_VISIT: {
    name: __t('components.promotion.boost.first-visit'),
    value: 'first_visit',
  },
  RETURNED: {
    name: __t('components.promotion.boost.returned'),
    value: 'returned',
  },
  CLAIM_PENDING: {
    name: __t('components.promotion.boost.claim-pending'),
    value: 'claim_pending',
  },
  CLAIM_DENIED: {
    name: __t('components.promotion.boost.claim-denied'),
    value: 'claim_denied',
  },
  CLAIM_OVERDUE: {
    name: __t('components.promotion.boost.claim-overdue'),
    value: 'claim_overdue',
  },
  CLAIMED: {
    name: __t('components.promotion.boost.claimed'),
    value: 'claimed',
  },
  NO_SHOW_OVERDUE: {
    name: __t('components.promotion.boost.no-show-overdue'),
    value: 'no_show_overdue',
  },
}

export const BOOST_CLIENTS_LIST_STATUS = {
  NEW: 'new',
  RETURNING: 'returning',
  CLAIMED: 'claimed',
}

export const ANIMATED_STATUSES = ['active', 'running', 'suspension_pending']

export const ANIMATED_COLOR_STATUSES = ['green', 'orange']

export const BLAST_SEND_MODE = {
  Automatic: 'A',
  Manual: 'M',
}

export const CELERY_TIME_INTERVAL = 2000

export const TEMPLATE_DETAILS_MESSAGE_MAX_LENGTH = 304

export const TILES_ORDER = {
  [PROMOTION_FEATURES_KEYS['visibility-promotion']]: 1,
  [PROMOTION_FEATURES_KEYS['invite-customers']]: 2,
  [PROMOTION_FEATURES_KEYS['boost']]: 3,
  [PROMOTION_FEATURES_KEYS['social-media']]: 4,
  [PROMOTION_FEATURES_KEYS['message-blast']]: 5,
  [PROMOTION_FEATURES_KEYS['special-offers']]: 6,
}

export const FLASH_SALE_ENTRY_SOURCE_KEY = 'entry_source'

export const FLASH_SALE_ENTRY_POINTS = {
  BLACK_FRIDAY_BANNER: 'black_friday_banner',
  VALENTINES_DAY_BANNER: 'valentines_day_banner',
}

export const PROMOTION_ROUTE_KEYS = {
  INVITE_CUSTOMERS: 'invite-customers',
  MESSAGE_BLAST: 'message-blast',
  BOOST: 'boost',
  SPECIAL_OFFERS: 'special-offers',
  SOCIAL_MEDIA: 'social-media',
  VISIBILITY_PROMOTION: 'visibility-promotion',
}

export const PROMOTION_EXTERNAL_ROUTE_KEYS = {
  GOOGLE_BUSINESS_PROFILE: 'promotion.google-business-profile',
  LOYALTY_PROGRAM: 'settings.loyalty-program',
  SOCIAL_MEDIA_BOOKINGS: 'settings-online-booking',
}

export const MARKETING_EVENT_ACTIONS_MAP = {
  [PROMOTION_ROUTE_KEYS.INVITE_CUSTOMERS]: EVENT_ACTIONS.INVITE_IMPORT_CLICKED,
  [PROMOTION_ROUTE_KEYS.SOCIAL_MEDIA]: EVENT_ACTIONS.SPC_CLICKED,
  [PROMOTION_ROUTE_KEYS.MESSAGE_BLAST]: EVENT_ACTIONS.MB_CLICKED,
  [PROMOTION_ROUTE_KEYS.SPECIAL_OFFERS]: EVENT_ACTIONS.PROMOTIONS_CLICKED,
  [PROMOTION_ROUTE_KEYS.BOOST]: EVENT_ACTIONS.BOOST_CLICKED,
  [PROMOTION_ROUTE_KEYS.VISIBILITY_PROMOTION]: EVENT_ACTIONS.VISIBILITY_CLICKED,
}
